// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2TicP","col":"CardReaderDesc_col__3JfIK","label":"CardReaderDesc_label__uEcDz"};